var map = {
	"./anime.png": 570,
	"./circle.png": 795,
	"./cryo.png": 66,
	"./dendro.png": 220,
	"./diamond.png": 750,
	"./electro.png": 698,
	"./geo.png": 893,
	"./gold.png": 811,
	"./hydro.png": 659,
	"./iron.png": 507,
	"./pyro.png": 783,
	"./rumb.png": 427,
	"./square.png": 937,
	"./triangle.png": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 910;